import { defineComponent as P, mergeModels as E, ref as k, useModel as Z, computed as B, onUnmounted as q, createElementBlock as i, openBlock as l, createElementVNode as d, createBlock as T, createCommentVNode as r, withKeys as w, withModifiers as V, normalizeClass as s, renderSlot as m, Teleport as A, normalizeStyle as R, createVNode as G, Transition as J, withCtx as Q, Fragment as z, createTextVNode as H, toDisplayString as N, unref as D } from "vue";
import { u as W, b as X, o as Y, a as x, s as _, f as ee, c as te } from "./floating-ui.vue-CeIcpjeN.js";
import { o as oe } from "./index-gabsy7_d.js";
import "./vue3-lottie.es-BQlzj7s3.js";
import "./style-R_nxVIjQ.js";
/* empty css                                                */
/* empty css                                                         */
/* empty css                                                    */
import "./useDatePicker-DAFR8Jnp.js";
import "../config/index.js";
/* empty css                                                           */
import { _ as le } from "./UiIconButton.vue_vue_type_script_setup_true_lang-bU5oojc8.js";
/* empty css                                                       */
/* empty css                                                   */
/* empty css                                                  */
import { isMobileDevice as ie } from "../helpers/is-mobile-device.js";
/* empty css                                                    */
/* empty css                                                    */
/* empty css                                                    */
/* empty css                                                  */
/* empty css                                                      */
import "vue-router";
/* empty css                                                */
/* empty css                                                 */
/* empty css                                                      */
/* empty css                                                        */
/* empty css                                                    */
/* empty css                                                */
/* empty css                                                    */
/* empty css                                                               */
/* empty css                                                    */
const re = { class: "ui-tooltip" }, ne = {
  key: 0,
  class: "ui-tooltip__content"
}, se = { class: "ui-tooltip__content-inner" }, ae = {
  key: 1,
  class: "ui-tooltip__line"
}, Oe = /* @__PURE__ */ P({
  __name: "UiTooltip",
  props: /* @__PURE__ */ E({
    position: { default: "top" },
    title: { default: "" },
    text: { default: "" },
    showEvent: { default: "hover" },
    disabled: { type: Boolean, default: !1 },
    popperClass: { default: "" },
    timeout: { default: 100 },
    teleport: { type: [String, Boolean], default: "body" },
    isShowIconClose: { type: Boolean }
  }, {
    modelValue: { type: Boolean, default: !1 },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ E(["close", "click"], ["update:modelValue"]),
  setup(g, { emit: K }) {
    const h = K, n = g;
    let a = null;
    const f = k(null), b = k(null), v = k(null), o = Z(g, "modelValue");
    oe(
      v,
      (e) => {
        e && (o.value = !1);
      },
      { ignore: [f] }
    );
    const { x: $, y: M, middlewareData: L, placement: S } = W(f, v, {
      whileElementsMounted: X,
      placement: n.position,
      middleware: [
        Y(10),
        x(),
        _({
          apply({ availableHeight: e, elements: t }) {
            Object.assign(t.floating.style, {
              maxHeight: `${Math.max(300, e)}px`
            });
          }
        }),
        ee({
          fallbackStrategy: "initialPlacement"
        }),
        te({ element: b, padding: 30 })
      ]
    }), U = B(() => ({
      top: M.value != null ? `${M.value}px` : "",
      left: $.value != null ? `${$.value}px` : ""
    })), F = B(() => {
      const e = L.value.arrow, t = {
        top: "bottom",
        right: "left",
        bottom: "top",
        left: "right"
      }[S.value.split("-")[0]];
      return {
        left: e?.x != null ? `${e?.x}px` : "",
        top: e?.y != null ? `${e?.y}px` : "",
        right: "",
        bottom: "",
        [t]: "-8px"
      };
    });
    function I() {
      o.value = !1;
    }
    function O() {
      o.value = !0;
    }
    function u() {
      o.value = !o.value;
    }
    function j() {
      u(), h("close");
    }
    function c(e, t) {
      if (e === "click" && h("click"), ie())
        return e === "hover" ? void 0 : u();
      if (n.showEvent === "click" && e === "click")
        return u();
      if (n.showEvent === "hover" && e === "hover") {
        if (!o.value) return o.value = !0;
        t === "enter" ? (y(), o.value = !0) : t === "leave" && (a = setTimeout(() => o.value = !1, n.timeout));
      }
    }
    function C(e) {
      n.showEvent === "hover" && (e === "enter" ? y() : e === "leave" && (a = setTimeout(() => o.value = !1, n.timeout)));
    }
    function y() {
      a && clearTimeout(a);
    }
    return q(() => {
      y();
    }), (e, t) => (l(), i("div", re, [
      d("div", {
        role: "button",
        tabindex: "1",
        ref_key: "triggerRefer",
        ref: f,
        "aria-describedby": "tooltip",
        class: s(["ui-tooltip__trigger", { "click-event": e.showEvent === "click", "is-disabled": e.disabled }]),
        onMouseenter: t[0] || (t[0] = (p) => c("hover", "enter")),
        onMouseleave: t[1] || (t[1] = (p) => c("hover", "leave")),
        onKeydown: [
          w(u, ["enter"]),
          w(I, ["tab"])
        ],
        onClick: t[2] || (t[2] = V((p) => c("click"), ["stop", "prevent"])),
        onKeyup: w(O, ["tab"])
      }, [
        m(e.$slots, "default")
      ], 34),
      e.disabled ? r("", !0) : (l(), T(A, {
        key: 0,
        disabled: !e.teleport,
        to: typeof e.teleport == "string" ? e.teleport : "body"
      }, [
        d("div", {
          class: s([[{ "is-show": o.value }, { "click-event": e.showEvent === "click" }, e.popperClass], "ui-tooltip__content-wrapper"]),
          style: R(U.value),
          ref_key: "contentRefer",
          ref: v,
          role: "tooltip",
          onMouseenter: t[3] || (t[3] = (p) => C("enter")),
          onMouseleave: t[4] || (t[4] = (p) => C("leave"))
        }, [
          G(J, { name: "fade" }, {
            default: Q(() => [
              o.value && !e.disabled ? (l(), i("div", ne, [
                d("div", se, [
                  e.$slots.title || e.title ? (l(), i("div", {
                    key: 0,
                    class: s([{ "ui-tooltip__title": e.title }, "ui-tooltip--title"])
                  }, [
                    e.title ? (l(), i(z, { key: 0 }, [
                      H(N(e.title), 1)
                    ], 64)) : m(e.$slots, "title", { key: 1 }),
                    e.isShowIconClose ? (l(), T(D(le), {
                      key: 2,
                      onClick: V(j, ["stop"]),
                      "icon-color": "#fff",
                      "no-size": "",
                      "icon-name": "close",
                      "icon-type": "400",
                      size: "sm"
                    })) : r("", !0)
                  ], 2)) : r("", !0),
                  (e.$slots.title || e.title) && (e.$slots.text || e.text) ? (l(), i("div", ae)) : r("", !0),
                  e.$slots.text || e.text ? (l(), i("div", {
                    key: 2,
                    class: s({ "ui-tooltip__text": e.text })
                  }, [
                    e.text ? (l(), i(z, { key: 0 }, [
                      H(N(e.text), 1)
                    ], 64)) : m(e.$slots, "text", { key: 1 })
                  ], 2)) : r("", !0),
                  e.$slots.append ? m(e.$slots, "append", { key: 3 }) : r("", !0)
                ]),
                (l(), i("svg", {
                  ref_key: "arrowRefer",
                  ref: b,
                  width: "20",
                  height: "8",
                  viewBox: "0 0 20 8",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                  style: R(F.value),
                  class: s(["ui-tooltip__arrow", D(S)])
                }, t[5] || (t[5] = [
                  d("path", { d: "M9.89637 8L0 0L20 0L9.89637 8Z" }, null, -1)
                ]), 6))
              ])) : r("", !0)
            ]),
            _: 3
          })
        ], 38)
      ], 8, ["disabled", "to"]))
    ]));
  }
});
export {
  Oe as _
};
